
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import addressPicker from '@/views/components/address-picker'
import { getProvince,getCity,getCounty } from '@/api/sys.js'
import { addAddress,getAddressDefault,removeAddress,editAddress  } from '@/api/user.js'
import Storage from '@/storage'
export default {
name: 'addressadd',
data () {
return {
addressObj:{
address: '',
isdefault: 2,
provinceid: '',
cityid: '',
countyid: '',
name: '',
mobile: ''
},
isdefault:false,
ispopurShow:false,
addressValue: [],
addresslist:[],
addvalue:'',
ID:this.$route.params.ID
}
},
components: {
Group,
Cell,
XInput,
Selector,
PopupRadio,
XAddress,
XTextarea,
XSwitch,
Flexbox,
FlexboxItem,
XButton,
addressPicker
},
watch:{
value(val){
if(val){
this.obj.isdefault = 1;
}else{
this.obj.isdefault = 2;
}
},
addressValue(val){
this.addressObj.provinceid = val[0];
this.addressObj.cityid = val[1];
this.addressObj.countyid = val[2];
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
add(){
if( this.addressObj.name === ''){
this.$vux.toast.text('请填写姓名', 'middle')
return false
}
if( this.addressObj.mobile === ''){
this.$vux.toast.text('请填写电话', 'middle')
return false
}
if( !(/^1(3|4|5|7|8)\d{9}$/.test(this.addressObj.mobile))){
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
if( this.addressValue.length < 1){
this.$vux.toast.text('请选择所在省地市', 'middle')
return false
}
if( this.addressObj.address === ''){
this.$vux.toast.text('请填写详细地址', 'middle')
return false
}
if(this.isdefault){
this.addressObj.isdefault = 1
}else{
this.addressObj.isdefault = 2
}
let accountid = {accountid:this.accountid}
this.addressObj = Object.assign(this.addressObj,accountid)
addAddress(this.addressObj).then(res=>{

this.$router.go(-1)
})
},
getdefault (id) {
getAddressDefault({
addressid: id,
userid: this.userid,
accountid: this.accountid
}).then(data => {
this.addressObj.name = data.returnValue.NAME
this.addressObj.mobile = data.returnValue.MOBILE
this.$set(this.addressValue, 0, data.returnValue.PROVINCEID)
this.$set(this.addressValue, 1, data.returnValue.CITYID)
this.$set(this.addressValue, 2, data.returnValue.COUNTYID)
this.addressObj.address = data.returnValue.ADDRESS
if (data.returnValue.ISDEFAULT === 1) {
this.isdefault = true
} else {
this.isdefault = false
}
})
},
remove () {
removeAddress({
addressid: this.ID,
accountid: this.accountid
}).then(res => {
var that = this
this.$vux.confirm.show({
title: '删除',
content: '您确定要删除该地址吗！',
onCancel: () => {},
onConfirm: () => {
this.$vux.toast.text('删除成功', 'middle')

this.$router.go(-1)
}
})
})
},
edit(){
if( this.addressObj.name === ''){
this.$vux.toast.text('请填写姓名', 'middle')
return false
}
if( this.addressObj.mobile === ''){
this.$vux.toast.text('请填写电话', 'middle')
return false
}
if( !(/^1(3|4|5|7|8|9)\d{9}$/.test(this.addressObj.mobile))){
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
if( this.addressValue[0] == '0' && this.addressValue.length < 1){
this.$vux.toast.text('请选择所在省地市', 'middle')
return false
}
if( this.addressObj.address === ''){
this.$vux.toast.text('请填写详细地址', 'middle')
return false
}
if(this.isdefault){
this.addressObj.isdefault = 1
}else{
this.addressObj.isdefault = 2
}
editAddress({
addressid: this.ID,
accountid: this.accountid,
address: this.addressObj.address,
isdefault: this.addressObj.isdefault,
provinceid: this.addressObj.provinceid,
cityid: this.addressObj.cityid,
countyid: this.addressObj.countyid,
name: this.addressObj.name,
mobile: this.addressObj.mobile
}).then(res=>{
this.$vux.toast.text('地址修改成功', 'middle')

this.$router.go(-1)
})
},
},
activated () {
},
created () {
if(this.ID !== 0){
this.getdefault(this.ID)
}
}
}
